export default __webpack_public_path__ + "static/GT-Haptik-Regular-2-cb165322bd46b71468063b859bf862b2.ttf";